import React, { useRef, useState } from 'react'
import Header from 'src/components/shared/headers/mainHeader/Header'
import WomenCategorySelectSection from '../../WomanPageModal/WomenCategorySelectSection'
import CategorySlider from 'src/components/Category/CategoryComman/CategorySlider'
import SubCategoryProductSection from 'src/components/Category/CategoryComman/SubCategoryProductSection'
import CategorySmallBanner from 'src/components/BookAppliance/BookApplianceModal/BookApplianceShopByCategory/CategorySmallBanner'
import { WOMEN_CATEGORY } from 'src/Helpers/Json/WomanCategoryList'
import { fetchApplianceCategory } from 'src/store/slices/manageApplianceCategorySlice'
import { useSelector } from 'react-redux'
import { useAppDispatch } from 'src/store/store'
import { useRouter } from 'next/router'

export default function WomenCategoryModalMain() {
  const modalRef = useRef()
  const manageApplianceCategoryModal = useSelector((state: any) => state?.manageApplianceCategoryModal?.data)
  const dispatch = useAppDispatch()
  const router = useRouter()
  const [scrollY, setScrollY] = useState(0)
  const handleScroll = (event) => {
    setScrollY(event.target.scrollTop)
  }

  const handleClose = () => {
    router.push('/fashion/women/', undefined, { scroll: false })
    dispatch(fetchApplianceCategory({ modal: '', isOpen: false, id: 0 }))
  }

  return (
    <React.Fragment>
      <div
        ref={modalRef}
        onScroll={handleScroll}
        style={{
          width: '100%',
          height: '100%',
          overflow: 'auto',
        }}
      >
        <CategorySmallBanner
          categoryData={WOMEN_CATEGORY}
          scrollY={scrollY}
          handleClose={handleClose}
          pathname={'/fashion/women'}
        />
        {/* <WomenCategorySelectSection /> */}
        {/* <CategorySlider /> */}
        {/* <SubCategoryProductSection category={'Fashion & Accessories'} subCategory={'Women'} /> */}
      </div>
    </React.Fragment>
  )
}
